
  import { AccountModule, AccountStore } from '@/store/account';
  import { Options, Vue } from 'vue-class-component';
  import { NavigationModule, NavigationStore } from '@/store/navigation';
  import RegisterSuccessfull from '@/components/RegisterSuccessfull.vue';

  @Options({
    components: {
      RegisterSuccessfull
    }
  })
  export default class RegisterComponent extends Vue {
    private accountStore: AccountModule = AccountStore;
    private navigationStore: NavigationModule = NavigationStore;

    mounted() {
      this.accountStore.initAuthDataFromLocalStorage();
    }
  }
